export const USER_NAME_EXISTS_EXCEPTION = 'UsernameExistsException';
export const INVALID_PASSWORD_EXCEPTION = 'InvalidPasswordException';
